import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import React, { useState, useEffect, Suspense, lazy } from 'react';
import { string } from 'prop-types';
import propTypes from '@styled-system/prop-types';
import Svg from '../utils/SvgIcon';
import ErrorBoundary from './ErrorBoundary';
import useIcon from './useIcon';

const Icon = _ref => {
  let {
    name,
    fill,
    color
  } = _ref,
      props = _objectWithoutPropertiesLoose(_ref, ["name", "fill", "color"]);

  const [iconSymbolId, setIconSymbolId] = useState();
  const {
    addIconSymbol,
    icons,
    logger
  } = useIcon() || {};
  const iconColor = fill || color;
  const propsWith = Object.assign({}, props, {
    color: iconColor,
    fill: iconColor
  });
  useEffect(() => {
    if (addIconSymbol) {
      if (icons[name]) setIconSymbolId(icons[name].name);else {
        import(`../icons/${name}`).then(module => {
          const iconName = addIconSymbol(name, module.default);
          setIconSymbolId(iconName);
        }).catch(() => {
          logger.error(`invalid icon ${name}`);
        });
      }
    }
  }, [name]);

  if (addIconSymbol) {
    return !!iconSymbolId && /*#__PURE__*/React.createElement(Svg, propsWith, /*#__PURE__*/React.createElement("use", {
      xlinkHref: `#${iconSymbolId}`
    }));
  }

  if (typeof window !== 'object') return null;
  const TargetIcon = /*#__PURE__*/lazy(() => import(`../icons/${name}`));
  return /*#__PURE__*/React.createElement(ErrorBoundary, null, /*#__PURE__*/React.createElement(Suspense, {
    fallback: /*#__PURE__*/React.createElement(React.Fragment, null)
  }, /*#__PURE__*/React.createElement(TargetIcon, propsWith)));
};

process.env.NODE_ENV !== "production" ? Icon.propTypes = Object.assign({
  color: string,
  fill: string,
  name: string.isRequired
}, propTypes.layout) : void 0;
Icon.defaultProps = {
  color: '',
  fill: '',
  width: 24,
  height: 24
};
export default Icon;